import { configureStore } from '@reduxjs/toolkit';
import countryReducer from './currencySlice'

const store = configureStore({
  reducer: {
    country: countryReducer,
    // calculations: calculationsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
